export default __webpack_public_path__ + "img/bbw/bbw3.webm";